import Add from './add';
import Trial2paid from './trial2paid';
import BuyTrial from './buy-trial';
import { flowTypes } from '../../constant';

export default {
  [flowTypes.addTrial]: Add,
  [flowTypes.trial2paid]: Trial2paid,
  [flowTypes.add2cart]: Add,
  [flowTypes.buyTrial]: BuyTrial,
  [flowTypes.basic2trial]: BuyTrial,
};
